module.exports = __webpack_public_path__ + "img/03-Customer-Process.b91a607a.svg";